import { useState } from "react"
import { useNavigate } from "react-router";
import CategoriesMenuBar from "./Categories"

export default function Menu() {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    return (
        <div className="menuBar">
            <div className="navBar">
                <button onClick={() => navigate(-1)}> &#8617;</button>
            </div>
            <div className="menu">
                <button onClick={() => setOpen(!open)}>&#9776;</button>
                {open && <CategoriesMenuBar />}
            </div>
        </div>
    )   
}